const TOGGLE_MOBILE_MENU_STATUS = 'TOGGLE_MOBILE_MENU_STATUS';
const CLOSE_MOBILE_MENU_STATUS = 'CLOSE_MOBILE_MENU_STATUS';

export const toggleMobileMenuStatus = {
    type: TOGGLE_MOBILE_MENU_STATUS,
};

export const closeMobileMenuStatus = {
    type: CLOSE_MOBILE_MENU_STATUS,
};
